// import React, { useState } from "react";
// import CustomAccordian from "../Order/common/FilterScreen/filterAccordian";

// const TransactionFilter = ({ filterState, setFilterState }: any) => {
//   const [filterOptionList, setFilterOptionList] = useState([
//     {
//       name: "Status",
//       label: "status",
//       isCollapse: false,
//       menu: [
//         {
//           name: "DRAFT",
//           value: "DRAFT",
//           isActive: false,
//         },
//         {
//           name: "FAILED",
//           value: "FAILED",
//           isActive: false,
//         },
//         {
//           name: "ORDER_FAILED",
//           value: "ORDER_FAILED",
//           isActive: false,
//         },
//         {
//           name: "PENDING",
//           value: "PENDING",
//           isActive: false,
//         },
//         {
//           name: "Requested",
//           value: "Requested",
//           isActive: false,
//         },
//         {
//           name: "SUCCESS",
//           value: "SUCCESS",
//           isActive: false,
//         },
//         {
//           name: "TXN_FAILED",
//           value: "TXN_FAILED",
//           isActive: false,
//         },
//       ],
//     },
//   ]);
//   const [isLoading, setIsLoading] = useState<any>(false);

//   return (
//     <>
//       {filterOptionList &&
//         filterOptionList.map((singleAccordianDataList: any, i: any) => (
//           <CustomAccordian
//             key={`${i}_${singleAccordianDataList?.name}`}
//             cardClassName="lg:!px-0 lg:!mt-4"
//             filterListDatas={singleAccordianDataList}
//             isLoading={isLoading}
//             setFilterState={setFilterState}
//             filterState={filterState}
//           />
//         ))}
//     </>
//   );
// };

// export default TransactionFilter;


import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import CustomAccordian from "../Order/common/FilterScreen/filterAccordian";
import { POST } from "../../utils/webService";
import { GET_WALLET_DESCRIPTIONS_FINANCE } from "../../utils/ApiUrls";
import downArrowIcon from "../../assets/Filter/downArrow.svg";
import CrossIcon from "../../assets/cross.svg";

const DESCRIPTION_DEBOUNCE_MS = 600;
const DESCRIPTION_MIN_SEARCH_LENGTH = 1;
const WALLET_STATUS_FILTER_OPTIONS = [
  { name: "DRAFT", value: "DRAFT", isActive: false },
  { name: "FAILED", value: "FAILED", isActive: false },
  { name: "ORDER_FAILED", value: "ORDER_FAILED", isActive: false },
  { name: "PENDING", value: "PENDING", isActive: false },
  { name: "Requested", value: "Requested", isActive: false },
  { name: "SUCCESS", value: "SUCCESS", isActive: false },
  { name: "TXN_FAILED", value: "TXN_FAILED", isActive: false },
];

const TransactionFilter = ({
  filterState,
  setFilterState,
  filterPayLoad,
  setFilterPayLoad,
  filterModal,
  defaultOpenFilter,
  filterResetKey,
  setPersistFilterData,
  persistFilterData,
}: any) => {
  const [isLoading, setIsLoading] = useState<any>(false);
  const [descriptionSearch, setDescriptionSearch] = useState("");
  const [descriptionOptions, setDescriptionOptions] = useState<string[]>([]);
  const [descriptionOptionsLoading, setDescriptionOptionsLoading] = useState(false);
  const [allDescriptionOptions, setAllDescriptionOptions] = useState<string[]>([]);
  const [descriptionDropdownOpen, setDescriptionDropdownOpen] = useState(false);
  const [descriptionCollapse, setDescriptionCollapse] = useState(false);
  const descriptionDropdownRef = useRef<HTMLDivElement>(null);
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const selectedDescriptions = persistFilterData?.description || [];

  const filterOptionList = useMemo(() => {
    const selectedStatus = persistFilterData?.status || [];
    return [
      {
        name: "Status",
        label: "status",
        isCollapse: defaultOpenFilter === "Status",
        menu: WALLET_STATUS_FILTER_OPTIONS.map((item) => ({
          ...item,
          isActive: selectedStatus.includes(item.value),
        })),
      },
    ];
  }, [persistFilterData?.status, defaultOpenFilter, filterResetKey]);

  useEffect(() => {
    setDescriptionSearch("");
    setDescriptionDropdownOpen(false);
    setDescriptionCollapse(false);
  }, [filterResetKey]);

  const fetchDescriptions = useCallback(async (search: string) => {
    setDescriptionOptionsLoading(true);
    try {
      const { data } = await POST(GET_WALLET_DESCRIPTIONS_FINANCE, { search: search || "" });
      if (data?.success && Array.isArray(data?.data)) {
        setDescriptionOptions(data.data);
      } else {
        setDescriptionOptions([]);
      }
    } catch {
      setDescriptionOptions([]);
    } finally {
      setDescriptionOptionsLoading(false);
    }
  }, []);

  // Fetch initial (unsearched) description list when filter modal opens,
  // so empty search doesn't look blank.
  useEffect(() => {
    if (!filterModal) return;
    let isMounted = true;
    (async () => {
      setDescriptionOptionsLoading(true);
      try {
        const { data } = await POST(GET_WALLET_DESCRIPTIONS_FINANCE, { search: "" });
        const list = data?.success && Array.isArray(data?.data) ? data.data : [];
        if (!isMounted) return;
        setAllDescriptionOptions(list);
        // If dropdown is open and user hasn't typed anything, show full list
        if (descriptionDropdownOpen && descriptionSearch.trim().length < DESCRIPTION_MIN_SEARCH_LENGTH) {
          setDescriptionOptions(list);
        }
      } catch {
        if (!isMounted) return;
        setAllDescriptionOptions([]);
      } finally {
        if (!isMounted) return;
        setDescriptionOptionsLoading(false);
      }
    })();
    return () => {
      isMounted = false;
    };
  }, [filterModal]);

  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    if (!descriptionDropdownOpen) return;
    const search = descriptionSearch.trim();
    if (search.length < DESCRIPTION_MIN_SEARCH_LENGTH) {
      // Don't blank out; show the full list fetched on modal open
      setDescriptionOptions(allDescriptionOptions);
      return;
    }
    debounceRef.current = setTimeout(() => {
      fetchDescriptions(search);
    }, DESCRIPTION_DEBOUNCE_MS);
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, [descriptionSearch, descriptionDropdownOpen, fetchDescriptions, allDescriptionOptions]);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (descriptionDropdownRef.current && !descriptionDropdownRef.current.contains(e.target as Node)) {
        setDescriptionDropdownOpen(false);
      }
    };
    window.addEventListener("click", handleClickOutside);
    return () => window.removeEventListener("click", handleClickOutside);
  }, []);

  const applyDescriptionFilter = (menu: string[]) => {
    setFilterState({ name: "Description", label: "description", isCollapse: false, menu });
  };

  const onSelectDescription = (description: string) => {
    if (selectedDescriptions.includes(description)) return;
    const next = [...selectedDescriptions, description];
    applyDescriptionFilter(next);
  };

  const onRemoveDescription = (description: string) => {
    const next = selectedDescriptions.filter((d: string) => d !== description);
    applyDescriptionFilter(next);
  };

  return (
    <>
      {filterOptionList &&
        filterOptionList.map((singleAccordianDataList: any, i: any) => (
          <CustomAccordian
            key={`${filterResetKey}_${i}_${singleAccordianDataList?.name}_${defaultOpenFilter}`}
            cardClassName="lg:!px-0 lg:!mt-4"
            filterListDatas={singleAccordianDataList}
            isLoading={isLoading}
            setFilterState={setFilterState}
            filterState={filterState}
          />
        ))}

      {/* Description filter with auto-search */}
      <div className="flex flex-col mb-3 shadow-sm rounded-xl cursor-pointer lg:!px-0 lg:!mt-4">
        <div
          className={`flex items-center justify-between gap-3 px-3 py-3 border border-gray-200 ${
            descriptionCollapse
              ? "bg-[#f6f6f6] rounded-t-xl rounded-b-none"
              : "bg-white rounded-xl"
          }`}
        >
          <p
            className="font-semibold flex-1 text-[14px] text-[#1C1C1C] leading-tight"
            onClick={() => setDescriptionCollapse(!descriptionCollapse)}
          >
            Description
          </p>
          <div
            className="flex py-2 px-3 border-l rounded-r hover:bg-[#F6F6F6] bg-white rounded-lg"
            onClick={() => setDescriptionCollapse(!descriptionCollapse)}
          >
            <img
              src={downArrowIcon}
              alt="toggle"
              className={`transform w-[18px] transition-transform duration-400 ${descriptionCollapse ? "rotate-180" : ""}`}
            />
          </div>
        </div>
        {descriptionCollapse && (
          <div className="border-b border-r border-l border-gray-200 p-3 bg-white rounded-b-xl">
            <div className="relative" ref={descriptionDropdownRef}>
              <input
                type="text"
                placeholder="Search and select description..."
                value={descriptionSearch}
                onChange={(e) => {
                  setDescriptionSearch(e.target.value);
                  setDescriptionDropdownOpen(true);
                }}
                onFocus={() => setDescriptionDropdownOpen(true)}
                className="w-full border border-[#E8E8E8] rounded-md h-[36px] text-[14px] pl-3 pr-10 outline-none focus:border-[#1C1C1C]"
              />
              {descriptionSearch?.trim()?.length > 0 && (
                <img
                  src={CrossIcon}
                  alt="Clear"
                  className="absolute right-2 top-1/2 -translate-y-1/2 w-4 h-4 cursor-pointer opacity-70 hover:opacity-100"
                  onClick={() => {
                    setDescriptionSearch("");
                    setDescriptionDropdownOpen(true);
                    setDescriptionOptions(allDescriptionOptions);
                  }}
                />
              )}
              {descriptionDropdownOpen && (
                <div className="mt-2 w-full bg-white border border-[#E8E8E8] rounded-md shadow-sm max-h-[40vh] overflow-auto">
                  {descriptionOptionsLoading ? (
                    <div className="py-4 text-center text-sm text-[#666]">Loading...</div>
                  ) : descriptionOptions.length === 0 ? (
                    <div className="py-4 text-center text-sm text-[#666]">
                      {descriptionSearch ? "No descriptions found" : "No descriptions available"}
                    </div>
                  ) : (
                    descriptionOptions.map((opt, idx) => (
                      <div
                        key={`${idx}_${opt}`}
                        onClick={() => {
                          onSelectDescription(opt);
                          setDescriptionSearch("");
                          setDescriptionDropdownOpen(false);
                        }}
                        className="px-3 py-2 text-sm hover:bg-[#F6F6F6] cursor-pointer border-b border-[#E8E8E8] last:border-b-0"
                      >
                        {opt}
                      </div>
                    ))
                  )}
                </div>
              )}
            </div>
            {selectedDescriptions.length > 0 && (
              <div className="flex flex-wrap gap-2 mt-3">
                {selectedDescriptions.map((d: string) => (
                  <span
                    key={d}
                    className="inline-flex items-center gap-1 px-2 py-1 text-xs font-medium rounded-md bg-[#F0F0F0] text-[#1C1C1C]"
                  >
                    <span className="max-w-[200px] truncate" title={d}>{d}</span>
                    <button
                      type="button"
                      onClick={() => onRemoveDescription(d)}
                      className="ml-1 text-[#666] hover:text-[#1C1C1C] font-bold leading-none"
                      aria-label="Remove"
                    >
                      ×
                    </button>
                  </span>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default TransactionFilter;
